/**
 * Normalises a raw consent record for display in AG Grid tables.
 * - Resolves the consented countries list to a comma-separated string.
 * - Extracts the default contact (falls back to an empty contact object).
 */
export const mapConsentRow = (v) => {
    const consentedCountries =
        v.consentedCountriesList ?? v.consentedCountries ?? [];
    const consentedCountriesString = Array.isArray(consentedCountries)
        ? consentedCountries.join(', ')
        : consentedCountries;
    const defaultContact = v?.contacts?.find((x) => x.isDefault) ?? {
        companyName: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        companySize: '',
    };
    return { ...v, defaultContact, consentedCountriesString };
};
